// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__vEDNU","link":"breadcrumbs_link__rfyAI"};